import { FilterExpression } from "../../../Helpers/FilterExpressions/FilterExpression";
import { AbsoluteResolvedModelPath, RelativeResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";

export enum AggregationType {
    Sum,
    Count,
    Max,
    Min,
}

export type SelectAggregationClause =
    | {
          name?: string;
          type: AggregationType.Sum;
          relativeFieldPath: RelativeResolvedModelPath;
          customFieldName?: string;
      }
    | {
          name?: string;
          type: AggregationType.Count;
      };

export type SelectAggregationClauseResult = Big | undefined;
export interface IAggregationQueryResult {
    aggregations: SelectAggregationClauseResult[];
}

export interface IAggregationQueryStrategy {
    query(
        multilinePath: AbsoluteResolvedModelPath,
        filters: FilterExpression[],
        selects: SelectAggregationClause[],
        abortSignal?: AbortSignal
    ): Promise<IAggregationQueryResult>;
}
